import getQueues from '../../api/getQueues';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import TasksModule from '@modules/TasksModule';
import { authState } from '@modules/AuthModule/state';
import setQueueStatus from './setQueueStatus';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import requireUser from '../../lib/requireUser';
import { serviceState } from '../../lib/state';
import isValidUser from '../../lib/isValidUser';
import ToastModule from '@modules/ToastModule';

async function handleQueueSessionDelivered(
  event: Telecom.QueueSessionDeliveredEvent,
) {
  if (!isValidUser(event.agentId)) {
    log('invalid userId:', event.agentId);
    return;
  }

  const queue = getQueue(event.queueId);

  log('rtcs:queue:delivered:' + queue?.name, event);

  /**
   * Handle simultaneous ring (aka Ring All)
   *
   * If the task is offered to the current user but accepted by another agent,
   * we need to delete the task so that the task won't get stuck in the UI and
   * keep track of call events for the task. One caveat is that we don't want to
   * do this for outbound calls - the user could have made an outbound call via
   * a queue and we would get this event as soon as a user in the queue answers the call.
   *
   * We don't need to check if the queue is set to simultaneous ring because
   * we currently don't have any other scenario where an offered task is accepted
   * by another agent.
   *
   */
  const task = TasksModule.getTask(event.conversationSid);
  const { user } = authState;
  const userId = user?.id ?? '';
  const deliveredUserId = (await requireUser(event.agentId)).id ?? '';

  if (task && !task.isOutbound && userId !== deliveredUserId) {
    if (task.attributes?.isAnswering === true) {
      // if the task was accepted by the current the current user but delivered to another agent, then we show a toast message.
      ToastModule.showToast({
        title: 'Call was answered by another agent',
        status: 'info',
      });
    }
    TasksModule.deleteTask(event.conversationSid);
  }

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  setQueueStatus(queue, event);
}

export default handleQueueSessionDelivered;
